'use client';
import React from 'react';

import classnames from 'classnames';

interface Props<T> {
  header?: React.ReactNode;
  // injected by Tabs component
  handleTabClick?: (newKey: T) => void;
  id: T;
  selected?: boolean;
}

export const Tab = <T extends unknown>(props: React.PropsWithChildren<Props<T>>) => {
  const handleClick = React.useCallback(() => {
    const { handleTabClick, id } = props;
    if (handleTabClick && id) {
      handleTabClick(id);
    }
  }, [props]);

  const { header, selected } = props;

  return (
    <div className={classnames('Tab', { 'is-selected': selected })} onClick={handleClick}>
      {header}
    </div>
  );
};
